const doc = [({"ja":({"ocean":"オーシャン", "river":"リバー"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;